import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class InventoryItemEventQueryCriteriaClass extends BaseCriteriaModel {
  local_created_time_from?: Optional<string> = Optional.empty();
  local_created_time_to?: Optional<string> = Optional.empty();
  event_code?: Optional<string> = Optional.empty();
  app_id?: Optional<string> = Optional.empty();
  hdr_guid?: Optional<string> = Optional.empty();
}

export class InventoryItemEventCriteriaModelQuery {
  query = '';

  constructor(InventoryItemEventCriteriaModel: InventoryItemEventQueryCriteriaClass) {

    if (!InventoryItemEventCriteriaModel) {
      return;
    }

    this.query += InventoryItemEventCriteriaModel.local_created_time_from.filter(x => x !== '').map(x => '&local_created_time_from=' + x).orElse('');
    this.query += InventoryItemEventCriteriaModel.local_created_time_to.filter(x => x !== '').map(x => '&local_created_time_to=' + x).orElse('');
    this.query += InventoryItemEventCriteriaModel.event_code.filter(x => x !== '').map(x => '&event_code=' + x).orElse('');
    this.query += InventoryItemEventCriteriaModel.app_id.filter(x => x !== '').map(x => '&app_id=' + x).orElse('');
    this.query += InventoryItemEventCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');

    this.query += '&status=' + InventoryItemEventCriteriaModel.status;
    this.query += '&orderBy=' + InventoryItemEventCriteriaModel.orderBy;
    this.query += '&order=' + InventoryItemEventCriteriaModel.order;
    this.query += '&offset=' + InventoryItemEventCriteriaModel.offset + '&limit=' + InventoryItemEventCriteriaModel.limit;
  }
}
